<template>
  <sky-charts ref="chart"
              :queryCondition="condition"
              :config="chartConfig"
              legendPosition="bottom"
              :showTitle="false"
              :showShadow="false"
              :extend="extend"
              :chartData="data">
    <div slot="header"
         class="header">
      <el-select v-model="selectNum"
                 placeholder="展示次数"
                 size="mini"
                 @change="changeNum">
        <el-option v-for="item in fbChartsCount"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
        </el-option>
      </el-select>
      <div class="title">{{ tabName }}{{ selectName }}TOP10</div>
      <el-select v-model="selectPct"
                 placeholder="成效获得率"
                 size="mini"
                 @change="changePct">
        <el-option v-for="item in fbChartsRatio"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
        </el-option>
      </el-select>
    </div>
  </sky-charts>
</template>

<script>
import mixins from "./ga_mixins";
import { fbChartsCount, fbChartsRatio } from "@/common/dictionary.js";
import filters from "@/mixins/filters.js";
export default {
  name: "fb-series",
  mixins: [mixins],
  components: {},
  props: {
    activeClass: String,
  },
  data () {
    const that = this
    return {
      selectNum: "IMPRESSIONS", //排序字段
      selectPct: "effectiveRate",
      selectName: "展示次数",
      fbChartsCount,
      fbChartsRatio,
      tabName: "",
      tabItem: "",
      extend: {
        series: {
          type: 'bar',
          label: {
            show: true,
            position: "top",
            formatter (val) {
              return that.setFormatter(val)
            }
          },
          smooth: false
        },
        yAxis: {
          splitLine: {
            lineStyle: {
              type: "dotted",
              opacity: 0
            }
          }
        },
        tooltip: {
          show: true,
          formatter (val) {
            val.forEach(item => {
              that.setFormatter(item)
            });
            const fixedTooltip = [
              `${val[0].axisValue}<br>`,
              `${val[0].seriesName}：${val[0].value}<br>`,
              `${val[1].seriesName}：${val[1].value}<br>`
            ]
            let dynamicTooltip = {
              campaign: [],
              adGroup: [`所属广告系列：${that.data[val[0].dataIndex].campaignName}</br>`],
              ad: [
                `所属广告系列：${that.data[val[0].dataIndex].campaignName}</br>`,
                `所属广告组：${that.data[val[0].dataIndex].adGroupName}</br>`
              ]
            }
            return fixedTooltip.concat(dynamicTooltip[that.activeClass]).join('');
          }
        }
      },
      chartConfig: {
        name: "广告系列",
        type: "veHistogram",
        height: "400px",
        columns: [],
        chartSettings: {
          // 设置别名
          labelMap: {
            name: "名称",
            exchangeRateCost: "消耗",
            impressions: "展示次数",
            effect: '成效',
            covers: "覆盖人数",
            effectiveRate: "成效获得率",
            effectOnAverage: "成效均价",
          },
          // 双纵轴
          showLine: [],
          axisSite: {
            right: ["effectiveRate"]
          }
          // yAxisName: ["次", "%"]
        },
        grid: {
          left: 10,
          right: 10,
          top: 30
        }
      },
      label: {
        name: "名称",
        exchangeRateCost: "消耗",
        impressions: "展示次数",
        effect: '成效',
        covers: "覆盖人数",
        effectiveRate: "成效获得率",
        effectOnAverage: "成效均价",
      },
      data: []
    };
  },

  watch: {
    condition: {
      handler (val) {

        this.data = val.data;
        this.tabName = val.tabName;
        this.tabItem = val.tabItem;
        this.chartConfig.columns = [
          `${this.activeClass}Name`,
          this.switch(this.selectNum),
          this.selectPct
        ];
        this.chartConfig.chartSettings.showLine = [this.selectPct];
        this.chartConfig.chartSettings.axisSite.right = [this.selectPct];
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    setFormatter (val) {
      const rmb = (val) => filters.filters.rmb(val);
      const thousands = (val) => filters.filters.thousands(val);

      if (val.seriesName == "成效获得率") {
        val.value = val.value + "%";
        val.data = val.data + "%";
      }
      if (
        val.seriesName === "展示次数" ||
        val.seriesName === "成效" ||
        val.seriesName === "覆盖人数"
      ) {
        val.value = thousands(val.value);
        val.data = thousands(val.data);
      }
      if (val.seriesName === "成效均价" || val.seriesName === "消耗") {
        val.value = rmb(val.value);
        val.data = rmb(val.data);
      }
      return val.value
    },
    // 改变第二项指标
    changePct (val) {
      this.selectPct = val;
      this.chartConfig.columns = [
        `${this.activeClass}Name`,
        this.switch(this.selectNum),
        this.selectPct
      ];
      this.chartConfig.chartSettings.showLine = [this.selectPct];
      this.chartConfig.chartSettings.axisSite.right = [this.selectPct];
    },
    // 改变排序字段
    changeNum (val) {
      this.selectNum = val;
      this.$emit("googlereports", val);
      this.chartConfig.columns = [
        `${this.activeClass}Name`,
        this.switch(this.selectNum),
        this.selectPct
      ];
      this.chartConfig.chartSettings.showLine = [this.selectPct];
      this.chartConfig.chartSettings.axisSite.right = [this.selectPct];
    },
    switch (val) {
      var name = "";
      let that = this;

      let option = fbChartsCount.find(item => item.value == val)
      name = option.bind
      that.selectName = option.label

      return name;
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #000;
  .el-select {
    width: 130px;
    margin: 0 10px;
  }
}
</style>
